(function () {
    'use strict';

    angular
        .module('elogbooks.common.jobs.workflow', []);
})();
